export const isStringJSON = (input: string | object): boolean => {
    try {
        if(typeof input === "object"){
            return true;
        }
        JSON.parse(input);
        return true;
    }
    catch(e){
        return false;
    }
};
